module.exports = __webpack_public_path__ + "img/icon.1059ea9c.svg";